import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icons, Typography } from '../../../stories/atoms';
import { ColumnFlexContainer, RowFlexContainer } from '../../../stories/atoms/containerV2/ContainerV2';
import { IconWithText } from '../../../stories/molecules';
import { commonTranslations } from '../../../translations';
import { filterTranslations } from '../../../translations/filter';
import { StockDropdownType } from '../stockDropdown/StockDropdown';
import { StyledButton } from './StockFilter.styles';

type StockFilterProps = {
  selectedDepartment: string[];
  selectedIndex: string[];
  selectedSubindex: string[];
  onClose: (type: StockDropdownType, item: string) => void;
  onReset: () => void;
};

export const StockFilter: FC<StockFilterProps> = ({
  selectedDepartment,
  selectedIndex,
  selectedSubindex,
  onClose,
  onReset,
}) => {
  const { t } = useTranslation();
  const { selectedFilters: selectedFilterTranslation } = commonTranslations;
  const { clearAllButtonText } = filterTranslations;

  const filterConfigs = [
    { items: selectedDepartment, type: StockDropdownType.DEPARTMENT },
    { items: selectedIndex, type: StockDropdownType.INDEX },
    { items: selectedSubindex, type: StockDropdownType.SUBINDEX },
  ];

  return (
    <ColumnFlexContainer data-testid="stock-inventory-filters-wrapper">
      <RowFlexContainer justifyContent="between">
        <Typography>{t(selectedFilterTranslation.key, selectedFilterTranslation.defaultValue)}</Typography>
        <IconWithText
          data-testid="clear-all-button"
          label={t(clearAllButtonText.key, clearAllButtonText.defaultValue)}
          iconOptions={{
            icon: Icons.TRASHBIN,
            size: 'small',
          }}
          textOptions={{
            type: 'button',
          }}
          labelPosition="left"
          onClick={onReset}
          padding={[0, 0, 0, 2]}
        />
      </RowFlexContainer>
      <RowFlexContainer>
        {filterConfigs.map((config) =>
          config.items.map((item) => (
            <StyledButton
              data-testid={`selected-stock-filter-${config.type}`}
              key={item}
              label={item}
              padding={[1, 3]}
              iconOptions={{
                icon: Icons.CLOSE,
                size: 'small',
                margin: [0, 2],
              }}
              textOptions={{
                type: 'button',
                color: 'white',
              }}
              labelPosition="left"
              margin={[1, 2, 1, 0]}
              onClick={() => onClose(config.type, item)}
            />
          )),
        )}
      </RowFlexContainer>
    </ColumnFlexContainer>
  );
};
